module.exports = __webpack_public_path__ + "img/背了又忘.33273aa6.png";